import { ErrorType } from '../types';

import { NumberCompareFilter } from './number-compare-filter';

export class GreaterThanOtherFieldFilter extends NumberCompareFilter {
    constructor(otherFieldName: string) {
        super('greaterThan', otherFieldName);
    }

    compare(fieldValue: number, otherFieldValue: number): Array<ErrorType> {
        if (fieldValue <= otherFieldValue) {
            return [
                {
                    code: this.errorCode,
                    otherFieldName: this.otherFieldName,
                    otherFieldValue,
                },
            ];
        }
        return [];
    }
}
